import {
	type CreatorFlowStep,
	CreatorFlowStepKey,
	CreatorFlowStepStatus
} from '@/components/CreatorFlowLayout';

const ACTIVE_STEP_INDEX = 0;
const ACTIVE_STEP_PROGRESS_VALUE = 24;

export const BUSINESS_CONFIRMATION_FLOW_STEP_KEYS = [
	CreatorFlowStepKey.GettingToKnowYourBusiness,
	CreatorFlowStepKey.InitialAgentCustomization,
	CreatorFlowStepKey.AccountSetup,
	CreatorFlowStepKey.ExploringAgentCapabilities,
	CreatorFlowStepKey.QuickAgentTest,
	CreatorFlowStepKey.ScheduleMeetingWalkthrough,
	CreatorFlowStepKey.Review
] as const;

export const getBusinessConfirmationFlowSteps = (): CreatorFlowStep[] => {
	return BUSINESS_CONFIRMATION_FLOW_STEP_KEYS.map((stepKey, index) => ({
		key: stepKey,
		progressValue: index === ACTIVE_STEP_INDEX ? ACTIVE_STEP_PROGRESS_VALUE : 0,
		status:
			index === ACTIVE_STEP_INDEX
				? CreatorFlowStepStatus.Active
				: CreatorFlowStepStatus.Disabled
	}));
};
